export enum UserContactNature {
  FAX = 'fax',
  CELL = 'cell',
  EMAIL = 'email',
  LANDLINE = 'landline'
}

export interface UserContact {
  contact: string;
  id: number;
  nature: UserContactNature;
  nature_title: string;
  primary: boolean;
  public: boolean;
  user: number;
}

export interface MailSubscription {
  email: boolean;
  id: number;
  push: boolean;
  sms: boolean;
  template: MailSubscriptionTemplate;
}

export interface MailSubscriptionTemplate {
  category?: string | null;
  notification_settings: {
    description: string;
    title: string;
  };
  name: string;
  slug: string;
}
